import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState
} from "react";
import ChannelInfo from "../channelInfo";
import { getChannelPlayUrl } from "../../api/ltv/ltv";
import VideoPlayer from "../videoPlayer/VideoPlayer";
import { SessionContext } from "../../context/SessionContext";
import localizationStrings from "../../statics/localization";
import MyTvChannelInfo from "../myTvChannelInfo";
import { getVodPlayUrl } from "../../api/vod/vod";
/* import { getProgramPlayUrl } from "../../api/npvr/npvr"; */
import { getProgramAndNpvrThumbnail } from "../../api/common/commonApi";
import moment from "moment";
import { formatThumbnails } from "../../utils";
import { formatProgramThumbnails } from "../../utils/formatProgramThumbnails";
import { isSafari } from "react-device-detect";
import { getProgramPlayUrl } from "../../api/ltv/ltv";

import { channelPlaybackError, isChannelOutsidePackage } from "../../api/ltv/channelPlayback";
import ChannelPlaybackNotice from "./ChannelPlaybackNotice";

const options = {
  // fill: true,
  fluid: true,
  // responsive: true,
  preload: "auto",
  controls: true,
  liveui: true,
  autoplay: true,
  controlBar: {
    pictureInPictureToggle: false
  },
  html5: {
    nativeTextTracks: isSafari,
    dash: {
      useTTML: true
    }
  }
};

const ChannelDetail = ({
  selectedChannel,
  channels,
  genres,
  selectedGenre,
  setSelectedGenre,
  searchFilter,
  setCanWatch,
  setLockChannelCode
}) => {
  const [error, setError] = useState(null);
  const [isMyTvChannel, setIsMyTvChannel] = useState(false);
  const [thumbnails, setThumbnails] = useState([]);
  const [isTimeshiftEnable, setIsTimeshiftEnable] = useState(null);
  const [showAd, setShowAd] = useState(true);
  const [isPltv, setIsPltv] = useState(false);
  const [prevueCode, setPrevueCode] = useState(null);
  const [activeCutvProgram, setActiveCutvProgram] = useState(null);

  const {
    setSelectedChannel,
    userFrameConfig,
    selectedCutvProgram,
    setSelectedCutvProgram,
    isLiveSelected,
    setIsLiveSelected,
    userInfo,
    userPackage,
    playUrl,
    setPlayUrl,
    profilePin,
    programInfo
  } = useContext(SessionContext);
  const myTvChannelProgram = useRef(null);
  const ref = useRef(null);
  const channel = useRef(null);
  const livePlayUrl = useRef(null);
  const pltvPlayUrl = useRef(null);
  const playRequestSeq = useRef(0);
  const playbackRequest = useRef(null);
  const isChannelLocked =
    selectedChannel?.interactions?.includes("CHANNEL_LOCK") ||
    selectedChannel?.islocked === "1" ||
    selectedChannel?.isLocked === true;

  useLayoutEffect(
    () => () => {
      playRequestSeq.current += 1;
    },
    []
  );

  useEffect(() => {
    if (!selectedChannel?.id) {
      return;
    }

    // Hard reset channel-scoped playback state on channel switch.
    playRequestSeq.current += 1;
    myTvChannelProgram.current = null;
    livePlayUrl.current = null;
    pltvPlayUrl.current = null;
    setIsMyTvChannel(false);
    setIsPltv(false);
    setPrevueCode(null);
    setActiveCutvProgram(null);
    setThumbnails([]);
    setError(null);
    setSelectedCutvProgram(null);
    setIsLiveSelected(false);
    setPlayUrl(null);
  }, [selectedChannel?.id]);

  useEffect(() => {
    if (selectedChannel?.id) {
      getPlayUrl(selectedChannel.id);
    }
  }, [selectedChannel?.id, selectedChannel?.canWatch, selectedChannel?.parentalUnlocked, isChannelLocked]);

  const getChannelDetail = async (channelCode) => {
    livePlayUrl.current = null; //reset play url
    pltvPlayUrl.current = null;
    setIsPltv(false);

    channel.current = selectedChannel;
    if (isChannelOutsidePackage(selectedChannel)) {
      setIsTimeshiftEnable(false);
      setError({ code: 302 });
      return;
    }
    setIsTimeshiftEnable(
      channel.current.tsavailable !== "0" &&
      (channel.current.timeshiftenable === "1" || channel.current.isTimeshiftEnable === true)
    );
    if (channel.current.auth_returncode === "0") {
      if ((selectedChannel?.prevueratingid & (userInfo?.userlevel || 0)) > 0) {
        setError({ code: 101 });
        /* setPlayUrl(-1); */
      } else if (
        selectedChannel.islocked === "1" &&
        !selectedChannel?.parentalUnlocked
      ) {
        /* setPlayUrl(-1); */
        let err = {};
        err.code = 303;
        setError(err);
      } else {
        /* getPlayUrl(channel.current, 0); */
        // if (selectedChannel?.utcbegintime && selectedChannel?.utcendtime)
        //   getProgramThumbnail(
        //     moment(selectedChannel?.utcbegintime,"YYYY.MM.DD HH:mm").format("YYYYMMDDHHmmss"),
        //     moment(selectedChannel?.utcendtime,"YYYY.MM.DD HH:mm").format("YYYYMMDDHHmmss"),
        //     true
        //   );
      }
      if (parseInt(channel.current.advertisecontent) & 4) {
        setShowAd(true);
      } else {
        setShowAd(false);
      }
    } else if (
      channel.current.auth_returncode === "5" ||
      channel.current.auth_returncode === "-1"
    ) {
      let err = {};
      if (userInfo?.usertype === "0") {
        // should be logged in.
        err.code = 401;
        err.message = "you must logged in";
      } else {
        if (selectedChannel?.isppv === "1") {
          //program is pay per view program.
          err.code = 301;
          err.message = "PPV program";
        } else {
          err.code = 302;
        }
      }
      if (err.code) {
        setError(err);
      }
      /* setPlayUrl(-1); */
    }
  };

  const getPlayUrl = async (
    channelId,
    isPltv = false
  ) => {
    const requestSeq = ++playRequestSeq.current;
    if (isChannelOutsidePackage(selectedChannel)) {
      setPlayUrl(null);
      setError({ code: 302 });
      return;
    }
    setError(null);
    // Keep PlayerBar's pending seek/restart intent while the same channel switches to DVR.
    if (!isPltv) setPlayUrl(null);
    try {
      let programStartTime = null;
      if (isPltv) {
        const rawStartTime =
          activeCutvProgram?.startTime ??
          activeCutvProgram?.starttime ??
          activeCutvProgram?.begintime ??
          selectedChannel?.currentProgram?.startTime ??
          selectedChannel?.currentProgram?.starttime ??
          (programInfo?.channelcode === selectedChannel?.id
            ? programInfo?.startTime
            : selectedChannel?.startTime);

        if (typeof rawStartTime === "number" && Number.isFinite(rawStartTime)) {
          programStartTime = rawStartTime;
        } else if (typeof rawStartTime === "string" && rawStartTime.trim()) {
          const numericValue = Number(rawStartTime);
          if (!Number.isNaN(numericValue)) {
            programStartTime = numericValue;
          } else {
            const parsedDate = Date.parse(rawStartTime);
            if (!Number.isNaN(parsedDate)) {
              programStartTime = parsedDate;
            }
          }
        }
      }
      if (!isChannelLocked || selectedChannel?.parentalUnlocked) {
        playbackRequest.current = { channelId, startTime: programStartTime };
        const data = await getChannelPlayUrl(channelId, programStartTime);
        if (requestSeq !== playRequestSeq.current) {
          return;
        }
        let channelPlayUrl = data.data;

        // Check if the response indicates user can't access this content
        if (
          typeof channelPlayUrl === "string" &&
          channelPlayUrl.includes("Customer can't access this url.")
        ) {
          // Trigger the out-of-packet popup instead of setting error code 302
          setPlayUrl(-1);
          let err = {};
          err.code = 302; // Keep this for the video player error handling
          err.showOutOfPacketPopup = true; // Add a flag to trigger the popup
          setError(err);
        } else {
          setPlayUrl(normalizeStreamUrl(channelPlayUrl));
          setError(null);
        }
      } else {
        if (requestSeq !== playRequestSeq.current) {
          return;
        }
        setPlayUrl(-1);
        let err = {};
        err.code = 303;
        setError(err);
      }
    } catch (error) {
      if (requestSeq !== playRequestSeq.current) {
        return;
      }
      const playbackError = channelPlaybackError(error);
      setPlayUrl(playbackError.code === 303 ? -1 : null);
      setError(playbackError);
    }
  };

  const scrollToTop = () => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const refreshPlaybackSource = async (requestOptions) => {
    const sequence = playRequestSeq.current;
    const request = playbackRequest.current;
    if (isChannelOutsidePackage(selectedChannel) || (isChannelLocked && !selectedChannel?.parentalUnlocked)) {
      throw Error("CHANNEL_NOT_ENTITLED");
    }
    const programId = resolveProgramCode(activeCutvProgram);
    const response = programId
      ? await getProgramPlayUrl(programId, undefined, undefined, requestOptions)
      : await getChannelPlayUrl(selectedChannel.id, request?.startTime ?? null, requestOptions);
    if (sequence !== playRequestSeq.current) throw Error("Playback changed");
    return normalizeStreamUrl(response.data);
  };

  const normalizeStreamUrl = (url) => {
    if (typeof url !== "string") {
      return url;
    }
    return url
      .trim()
      .replace(/https:\s+\/\//i, "https://")
      .replace(/http:\s+\/\//i, "http://");
  };

  const normalizeCutvProgram = (program) => {
    if (!program) {
      return null;
    }

    const startTime =
      program?.startTime ??
      program?.starttime ??
      program?.begintime ??
      program?.utcbegintime;
    const endTime = program?.endTime ?? program?.endtime ?? program?.utcendtime;

    return {
      ...program,
      startTime,
      endTime,
      starttime: program?.starttime ?? startTime,
      endtime: program?.endtime ?? endTime,
      begintime: program?.begintime ?? startTime,
      prevuecode: program?.prevuecode ?? program?.epgProgramId
    };
  };

  const resolveProgramCode = (program) =>
    program?.prevuecode ||
    program?.epgProgramId ||
    program?.prevueCode ||
    program?.id ||
    program?.programcode;

  const getMyTvChannelProgramPlayUrl = async (item) => {
    if (!!item) {
      myTvChannelProgram.current = item;
      const { data } = await getVodPlayUrl(item.programcode, item.columncode);
      if (data.returncode === "0") {
        setError(null);
        /* setPlayUrl(data.httpsplayurl); */
      } else {
        /* let _error = {
          code: data.returncode,
          message:
            data.returncode === "1"
              ? localizationStrings.error.tvSubscription
              : data.errormsg
        };
        setError(_error);
        setPlayUrl(-1); */
      }
    } else {
      /* let _error = {
        code: "no code",
        message: "there is no current program"
      };
      setError(_error);
      setPlayUrl(-1); */
    }
  };

  const getProgramUrl = async (program, contentType = null) => {
    // Invalidate any in-flight live URL request so it cannot overwrite CUTV playback.
    const requestSeq = ++playRequestSeq.current;
    const normalizedProgram = normalizeCutvProgram(program);
    const resolvedProgramCode = resolveProgramCode(normalizedProgram);
    if (!resolvedProgramCode) {
      return;
    }
    setActiveCutvProgram(normalizedProgram);
    if (isChannelOutsidePackage(selectedChannel)) {
      setPlayUrl(null);
      setError({ code: 302 });
      return;
    }
    if (isChannelLocked && !selectedChannel?.parentalUnlocked) {
      setPlayUrl(-1);
      setError({ code: 303 });
      return;
    }
    setError(null);

    try {
      const data = await getProgramPlayUrl(
        resolvedProgramCode,
        normalizedProgram?.channelcode
          ? normalizedProgram?.channelcode
          : channel.current?.channelcode,
        contentType
      );
      if (requestSeq !== playRequestSeq.current) return;
      const responsePayload = data?.data;
      const resolvedUrl =
        typeof responsePayload === "string"
          ? responsePayload
          : responsePayload?.httpsplayurl;

      if (resolvedUrl) {
        setPlayUrl(normalizeStreamUrl(resolvedUrl));
        setError(null);
        if (normalizedProgram?.begintime && normalizedProgram?.endtime)
          getProgramThumbnail(
            moment(normalizedProgram.utcbegintime, "YYYY.MM.DD HH:mm").format(
              "YYYYMMDDHHmmss"
            ),
            moment(normalizedProgram.utcendtime, "YYYY.MM.DD HH:mm").format(
              "YYYYMMDDHHmmss"
            ),
            false,
            requestSeq
          );
      }
    } catch (err) {
      if (requestSeq !== playRequestSeq.current) return;
      const playbackError = channelPlaybackError(err);
      setPlayUrl(playbackError.code === 303 ? -1 : null);
      setError(playbackError);
    }
  };

  const getProgramThumbnail = async (
    beginTime,
    endTime,
    isLive = false,
    requestSeq = playRequestSeq.current
  ) => {
    if (!userFrameConfig?.cmsid || !channel.current?.cdnchannelcode) return;
    try {
      const { data } = await getProgramAndNpvrThumbnail(
        userFrameConfig.cmsid,
        channel.current.cdnchannelcode,
        beginTime,
        endTime
      );
      if (requestSeq !== playRequestSeq.current) return;
      if (data.returncode === "0") {
        if (isLive) {
          setThumbnails(data);
        } else {
          setThumbnails(formatProgramThumbnails(data, beginTime, endTime));
        }
      } else {
        setThumbnails([]);
      }
    } catch (error) {
      if (requestSeq === playRequestSeq.current) setThumbnails([]);
    }
  };

  const switchToLive = () => {
    const liveChannelId = channel.current?.id || selectedChannel?.id;
    if (!liveChannelId) {
      return;
    }

    setIsPltv(false);
    setActiveCutvProgram(null);
    setSelectedCutvProgram(null);
    setPrevueCode(null);

    getPlayUrl(liveChannelId);
  };

  useEffect(() => {
    if (selectedChannel) {
      /*    if (userInfo.usertype === "0") {
          // should be logged in.
          let err = {};
          err.code = 401;
          err.message = "you must logged in";
          setError(err);
          setPlayUrl(-1);
        }
        setIsMyTvChannel(true); */
      getChannelDetail(selectedChannel?.id);
      setIsMyTvChannel(false);
    }
  }, [selectedChannel?.id, selectedChannel?.canWatch, selectedChannel?.parentalUnlocked, isChannelLocked]);

  useEffect(() => {
    const resolvedProgramCode = resolveProgramCode(selectedCutvProgram);
    if (resolvedProgramCode) {
      const normalizedSelectedProgram =
        normalizeCutvProgram(selectedCutvProgram);
      setActiveCutvProgram(normalizedSelectedProgram);
      setIsPltv(true);
      setPrevueCode(resolvedProgramCode);
      getProgramUrl(
        normalizedSelectedProgram,
        normalizedSelectedProgram?.isppv === "1" ? 18 : null
      );
    }
    return () => {
      // setSelectedCutvProgram(null);
    };
  }, [selectedCutvProgram]);

  useEffect(() => {
    if (isLiveSelected) {
      console.log("useeffect2 getplay");
      switchToLive();
      setIsLiveSelected(false);
    }
  }, [isLiveSelected]);

  return (
    <div
      ref={ref}
      style={{
        width: "100%",
        scrollMarginTop: "calc(var(--atlas-nav-height, 80px) + 20px)"
      }}
    >
      {error?.code === 302 || error?.code === 503 ? (
        <ChannelPlaybackNotice denied={error.code === 302} onRetry={() =>
          activeCutvProgram ? getProgramUrl(activeCutvProgram) : getPlayUrl(selectedChannel.id)
        } />
      ) : playUrl ? (
        <VideoPlayer
          key={`ltv-player-${selectedChannel?.id || "none"}`}
          options={options}
          isTimeshiftEnable={isTimeshiftEnable}
          src={playUrl}
          refreshPlaybackSource={refreshPlaybackSource}
          channel={selectedChannel}
          setSelectedChannel={setSelectedChannel}
          error={error}
          myTvChannelProgram={myTvChannelProgram.current}
          cuTvProgram={activeCutvProgram}
          setIsLiveEdge={(val) => {
            if (val === "0") {
              console.log("val0 getplay");
              switchToLive();
            } else if (val === "1") {
              setIsPltv(true);
              console.log("val1 getplay");
              if (activeCutvProgram) {
                getProgramUrl(
                  activeCutvProgram,
                  activeCutvProgram?.isppv === "1" ? 18 : null
                );
              } else {
                getPlayUrl(channel.current.id, true);
              }
            } else if (val === "2") {
              //if tstv is playing, clicked back live
              switchToLive();
            }
          }}
          isPltv={isPltv}
          thumbnails={thumbnails}
          showAd={showAd}
          channelCdnCode={selectedChannel?.cdnchannelcode}
          channels={channels}
          genres={genres}
          selectedGenre={selectedGenre}
          setSelectedGenre={setSelectedGenre}
          searchFilter={searchFilter}
          prevueCode={prevueCode}
          setCanWatch={setCanWatch}
          setLockChannelCode={setLockChannelCode}
          setPltv={(val) => setIsPltv(val)}
        />
      ) : null}
      {isMyTvChannel ? (
        <MyTvChannelInfo
          myChannel={selectedChannel}
          day={userFrameConfig.My_TV_Channel_Days}
          getProgramPlayUrl={getMyTvChannelProgramPlayUrl}
          scrollToTop={() => scrollToTop()}
        />
      ) : (
        <ChannelInfo
          isPltv={isPltv}
          scrollToTop={() => scrollToTop()}
          isTimeshiftEnable={isTimeshiftEnable}
          setCanPlayPpv={(isPlay, productCode) => {
            if (isPlay) {
              console.log("isplay getplay");

              getPlayUrl(selectedChannel?.id);
            }
          }}
          setPrevueCode={(val) => setPrevueCode(val)}
        />
      )}
    </div>
  );
};

export default ChannelDetail;
